import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AssetTableHead = ({
  sortColumn,
  sortOrder,
  handleSort,
  columnSearch,
  onColumnSearchChange,
    onSearchSubmit, 
}) => {
  return (
    <thead className="sticky top-0 z-10 bg-[#1a0020] text-[#fff] font-medium">
      <tr>
        <th
          onClick={() => handleSort("domain_name")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
        >
          <span className="flex items-center gap-1">
            Domain
            {sortColumn === "domain_name" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("sub_domain_name")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "sub_domain_name" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Sub Domain
            {sortColumn === "sub_domain_name" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("product_name")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[200px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "product_name" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Data Product Name
            {sortColumn === "product_name" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("region")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[170px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "region" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Region
            {sortColumn === "region" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("data_asset_name")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "data_asset_name" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Data Asset Name
            {sortColumn === "data_asset_name" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("frequency")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "frequency" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Frequency
            {sortColumn === "frequency" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("execution_date")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[160px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "execution_date" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Execution Date
            {sortColumn === "execution_date" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>

        <th
          onClick={() => handleSort("total_dq_score")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "total_dq_score" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Total DQ Score
            {sortColumn === "total_dq_score" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>
        <th
          onClick={() => handleSort("status")}
          className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[180px] cursor-pointer select-none"
        >
          <span
            className={`flex items-center gap-1 ${
              sortColumn === "status" ? "text-[#bb1ccc]" : ""
            }`}
          >
            Status
            {sortColumn === "status" ? (
              sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
            ) : (
              <ArrowUp size={12} className="opacity-30" />
            )}
          </span>
        </th>
      </tr>

      <tr>
        {[
          "domain_name",
          "sub_domain_name",
          "product_name",
          "region",
          "data_asset_name",
          "frequency",
        ].map((key, i) => (
          <th key={i} className="px-4 pt-0 pb-[10px]">
            <input
              className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
              placeholder="Search"
             value={columnSearch[key] || ""}
  onChange={(e) => onColumnSearchChange(key, e.target.value)}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      onSearchSubmit(key, e.target.value);
    }
  }}
            />
          </th>
        ))}
        <th className="px-4 pt-0 pb-[10px]">
          <DatePicker
            selected={columnSearch.execution_date ? new Date(columnSearch.execution_date) : null}
            onChange={(date) => {
              if (date) {
                const formatted = date.toLocaleDateString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                });
                onColumnSearchChange("execution_date", formatted);
                onSearchSubmit("execution_date", formatted);
              } else {
                onColumnSearchChange("execution_date", "");
                onSearchSubmit("execution_date", "");
              }
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Search"
            isClearable
            showMonthDropdown
            showYearDropdown
            scrollableYearDropdown
            className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
          />
        </th>
        <th className="px-4 pt-0 pb-[10px]">
          <input
            className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
            placeholder="Search"
            value={columnSearch.total_dq_score || ""}
            onChange={(e) => onColumnSearchChange("total_dq_score", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearchSubmit("total_dq_score", e.target.value);
              }
            }}
          />
        </th>
         <th className="px-4 pt-0 pb-[10px]">
          <input
            className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
            placeholder="Search"
            value={columnSearch.status || ""}
            onChange={(e) => onColumnSearchChange("status", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearchSubmit("status", e.target.value);
              }
            }}
          />
        </th>
      </tr>
    </thead>
  );
};

export default AssetTableHead;
